<template>
  <div>
    <b-sidebar
      id="sidebar-new-franchise"
      sidebar-class="sidebar-lg"
      :visible="newFranchiseSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @shown="onShow"
      @change="(val) => mutateNewFranchiseSidebar({ visible: val })"
      @hidden="clear"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h4 v-if="newFranchiseSidebar.edit">Editar escritório</h4>
          <h4 v-if="newFranchiseSidebar.visualizar">Visualizar escritório</h4>
          <h4
            v-if="!newFranchiseSidebar.visualizar && !newFranchiseSidebar.edit"
          >
            Novo escritório
          </h4>
          <div>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        <div class="m-2" v-if="newFranchiseSidebar.visualizar">
          <b-row>
            <b-col cols="4" class="mb-1"> Nome: </b-col>
            <b-col cols="8" class="mb-1"> {{ newFranchiseSidebar.name }}</b-col>

            <b-col cols="4" class="mb-1"> Responsáveis: </b-col>
            <b-col cols="8" class="mb-1">
              <div
                class="text-wrap"
                v-for="(name, index) in newFranchiseSidebar.franchiseOwner"
                :key="`franchise-${index}`"
              >
                <span class="align-text-top text-capitalize">{{ name }}</span>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Form -->
        <b-form
          v-if="!newFranchiseSidebar.visualizar"
          class="p-2"
          @submit.prevent="onSubmit"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome" label-for="lead-name">
                <b-form-input
                  id="lead-name"
                  v-model="name"
                  :class="{ 'is-invalid': v$.name.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.name.$invalid">
                    Você deve informar o nome da franquia
                  </span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="mt-1">
              <b-form-group label="Responsáveis" label-for="pn-franchiseOwner">
                <v-select
                  id="pn-franchiseOwner"
                  v-model="franchiseOwner"
                  :options="franchiseOwners"
                  :loading="loading.franchiseOwners"
                  :reduce="(reponse) => reponse.id"
                  multiple
                  label="name"
                  :class="getSelectErrorClass(v$.franchiseOwner.$error)"
                  :disabled="newFranchiseSidebar.edit"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
                <div class="invalid-feedback">
                  <span v-if="v$.franchiseOwner.required.$invalid">
                    Você deve selecionar pelo menos um responsável
                  </span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-between">
            <b-button
              :disabled="saving"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              @click="hide"
              class="lead-buttons"
            >
              Voltar
            </b-button>
            <b-button
              v-if="newFranchiseSidebar.edit"
              :disabled="saving"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="lead-buttons"
            >
              {{ saving ? "Salvando..." : "Editar" }}
            </b-button>
            <b-button
              v-else
              :disabled="saving"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="lead-buttons"
            >
              {{ saving ? "Salvando..." : "Salvar" }}
            </b-button>
          </div>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BButton,
  BSidebar,
  BForm,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BFormFile,
  BCol,
  BRow,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import DynamicSelect from "@/modules/shared/components/DynamicSelect";
import FileChooser from "@/modules/shared/components/FileChooser";
import * as types from "../store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import { getVueSelectErrorClass } from "@/helpers/validators";
import AllSelect from "@/modules/shared/components/AllSelect";

export default {
  components: {
    // BSV
    BButton,
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormFile,
    BCol,
    BRow,
    vSelect,
    DynamicSelect,
    FileChooser,
    BFormCheckbox,
    AllSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: {
        franchiseOwners: false,
      },
      name: "",
      franchise_visible: true,
      franchiseOwner: [],
      saving: false,
    };
  },
  setup() {
    return { toast: useToast(), v$: useVuelidate() };
  },
  validations() {
    return {
      name: { required },
      franchiseOwner: {
        required: (value) => {
          if (this.newFranchiseSidebar.edit) {
            return true;
          }
          return value.length > 0;
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      newFranchiseSidebar: types.NEW_PHYSICAL_FRANCHISE_SIDEBAR,
      franchiseOwners: sharedTypes.CONSULTANTS,
    }),
  },
  methods: {
    ...mapMutations({
      mutateNewFranchiseSidebar: types.MUTATE_NEW_PHYSICAL_FRANCHISE_SIDEBAR,
    }),
    ...mapActions({
      getFranchise: types.GET_PHYSICAL_FRANCHISE,
      getPhysicalFranchiseOwners: sharedTypes.GET_CONSULTANTS,
      storeFranchise: types.STORE_PHYSICAL_FRANCHISE,
      editFranchise: types.EDIT_PHYSICAL_FRANCHISE,
    }),
    onShow() {
      this.loading.franchiseOwners = true;
      this.getPhysicalFranchiseOwners()
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar os objetivos para seleção. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading.franchiseOwners = false;
        });

      if (this.newFranchiseSidebar.id) {
        this.getFranchise({ id: this.newFranchiseSidebar.id })
          .then((resp) => {
            var data = resp.data;
            if (data) {
              this.name = data.name;
              this.franchiseOwner = data.physical_franchise_owners.map(
                (item) => item.appify_consultant
              );
              this.v$.$touch();
            }
          })
          .catch(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao carregar a franquia para edição. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.saving = true;

      const { name, franchiseOwner } = this;

      const payload = {
        id: this.newFranchiseSidebar?.id,
        name,
      };

      if (!this.newFranchiseSidebar.edit) {
        payload.physical_franchise_owners = franchiseOwner;
      }

      if (this.newFranchiseSidebar.id) {
        this.editFranchise(payload)
          .then((response) => {
            // Handle success
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Sucesso",
                text: "Escritório alterado com sucesso!",
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
            this.mutateNewFranchiseSidebar({ visible: false });
            this.newFranchiseSidebar.saveAction();
          })
          .catch(() => {
            // Handle error
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao editar o escritório. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.clear();
            this.saving = false;
          });
      } else {
        this.storeFranchise(payload)
          .then((response) => {
            // Handle success
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Sucesso",
                text: "Escritório salvo com sucesso!",
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
            this.mutateNewFranchiseSidebar({ visible: false });
            this.newFranchiseSidebar.saveAction();
          })
          .catch((error) => {
            // Handle error
            if (error.response.status === 405) {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: `${error.response.data.message}.`,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            } else {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: `Ocorreu um erro ao salvar o escritório. Entre em contato com o setor de TI.`,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            }
          })
          .finally(() => {
            this.clear();
            this.saving = false;
          });
      }
    },

    getSelectErrorClass(thereIsError) {
      return getVueSelectErrorClass(thereIsError);
    },

    clear() {
      this.name = "";
      this.franchiseOwner = null;
      this.v$.$reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-tel-input {
  padding: 0.438rem 1rem;
}
</style>
<style lang="scss">
.sidebar-xg {
  width: 36rem;
}

.lead-buttons {
  width: 10rem;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Buscar";
}

.resume-download-col {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
